<template>
	<sf-data-table
		ref="RoApcnTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="roApcnCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		selection
		fit
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->

			<!--RO 신청-->
			<sf-button v-if="isButton_(scrId, 'CC')" line icon="file" :onClick="openRoNewModal">
				{{ getMessage_('QWCC001042') }}
			</sf-button>

			<!-- 고품회수(요청)-->
			<sf-button v-if="isButton_(scrId, 'CC') && btnCk1" line icon="file" :onClick="openRtnPartModal">
				{{ getMessage_('QWCC001172') }}
			</sf-button>

			<!-- RO 일괄승인-->
			<sf-button v-if="isButton_(scrId, 'CC') && btnCk1" line icon="file" :onClick="roListAppr">
				{{ getMessage_('QWCC001988') }}
			</sf-button>

			<sf-button v-if="isButton_(scrId, 'CS') && btnCk1" line icon="menu-production" :onClick="outBound">
				{{ getMessage_('QWCC002149') }}
			</sf-button>

			<!-- <sf-button v-if="isButton_(scrId, 'CS') && btnCk1" line icon="menu-production" :onClick="costUpShow">
				导入ERP成本
			</sf-button>

			<sf-button v-if="isButton_(scrId, 'CS') && btnCk1" line icon="menu-production" :onClick="roCostMatch">
				工单成本匹配
			</sf-button>  -->
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
/*엑셀다운로드 시작*/
import utils from '@/utils';
import moment from 'moment';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		btnCk1() {
			if(this.isMqyStation){
				return false;
			}else{
				return true;
			}
		},
		rows() {
			//그리드 로우
			return this.roApcnList;
		},
		roApcnCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001180'), //정비유형
					prop: 'ceqTypeNm',
					width: '100px',
					highlight: false,
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001056'), // ctype
					prop: 'ctypeNm',
					width: '170px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000976'), //Ro No
					prop: 'roNo',
					width: '170px',
					highlight: true,
					align: 'center',
					clickEvent: this.openRoEditModal
				},
				{
					label: this.getMessage_('QWCC000969'), //PWN No
					prop: 'pwaNo',
					width: '170px',
					highlight: true,
					align: 'center',
					clickEvent: this.openPwaModal
				},
				{
					label: this.getMessage_('QWCC001177'), // 캠페인번호
					prop: 'cmpnNo',
					width: '170px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001007'), // 캠페인명
					prop: 'cmpnNm',
					width: '100px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC000963'), // 처리단계
					prop: 'prcsStepNm',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000978'), // 처리결과
					prop: 'prcsRsltNm',
					width: '80px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001238'), // 고품회수상태
					prop: 'rptpStNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002149') + this.getMessage_('SWCC000141'), // 고품회수상태
					prop: 'outBoundStatus',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001096'), // op代码
					prop: 'causOpCd',
					width: '200px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000053'), // 고품회수상태
					prop: 'prtlSbc',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001538'), // 제품ID
					prop: 'pmcId',
					width: '220px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), // 품번
					prop: 'causPartNo',
					width: '200px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('MWCC000957'), // 품번명
					prop: 'causPartNm',
					headerAlign: 'center',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000970'), // 딜러점코드
					prop: 'dlrCpnyCd',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000959'), // 딜러점
					prop: 'dlrCpnyNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000960'), // 차량VIN
					prop: 'carVin',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002119'), // 车牌号
					prop: 'licensePlate',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					width: '150px',
					headerAlign: 'center',
					align: 'right'
				},

				{
					label: this.getMessage_('QWCC001237'), //'R/O 금액',
					width: '700px',
					align: 'center',
					children: [
						{
							label: this.getMessage_('QWCC001101'), //자재비
							width: '100px',
							prop: 'mtrlCst',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC001102'), //'공임비',
							width: '100px',
							prop: 'wags',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC001103'), //'부대비',
							width: '100px',
							prop: 'incdCst',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC002137'), //'부대비',
							width: '100px',
							prop: 'dlrCpnyFee',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC002138'), //'부대비',
							width: '100px',
							prop: 'nonWarrantyFee',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC002139'), //'부대비',
							width: '100px',
							prop: 'warrantyFee',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC001104'), //'총금액',
							width: '100px',
							prop: 'totPartCst',
							align: 'right'
						}
					]
				},
				{
					label: this.getMessage_('QWCC001184'), // 维修完成日
					prop: 'ceqEndDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000979'), // 신청일자
					prop: 'aplcDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('MWCC000980'), // 확정일자
					prop: 'dcsnDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001251'), //신청자
					prop: 'aplcNm',
					width: '130px',
					align: 'center'
				}
			];
		},
		roApcnExCols() {
			//엑셀컬럼
			return [
				{
					label: this.getMessage_('QWCC001180'), //정비유형
					prop: 'ceqTypeNm',
					width: '100px',
					highlight: false,
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001056'), // ctype
					prop: 'ctypeNm',
					width: '170px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000976'), //Ro No
					prop: 'roNo',
					width: '200px',
					highlight: true,
					align: 'center',
					clickEvent: this.openRoEditModal
				},
				{
					label: this.getMessage_('QWCC000969'), //PWN No
					prop: 'pwaNo',
					width: '200px',
					highlight: true,
					align: 'center',
					clickEvent: this.openPwaModal
				},
				{
					label: this.getMessage_('QWCC001177'), // 캠페인번호
					prop: 'cmpnNo',
					width: '170px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001007'), // 캠페인명
					prop: 'cmpnNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000963'), // 처리단계
					prop: 'prcsStepNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000978'), // 처리결과
					prop: 'prcsRsltNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001238'), // 고품회수상태
					prop: 'rptpStNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001538'), // 제품ID
					prop: 'pmcId',
					width: '250px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), // 품번
					prop: 'causPartNo',
					width: '200px',
					align: 'left'
				},
				{
					label: this.getMessage_('MWCC000957'), // 품번명
					prop: 'causPartNm',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001096'), // op代码
					prop: 'causOpCd',
					width: '200px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001807'), // op代码名
					prop: 'causOpNm',
					width: '200px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC002149') + this.getMessage_('SWCC000141'), // 出库状态
					prop: 'outBoundStatus',
					width: '200px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000970'), // 딜러점코드
					prop: 'dlrCpnyCd',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000959'), // 딜러점
					prop: 'dlrCpnyNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000960'), // 차량VIN
					prop: 'carVin',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002119'), // 车牌号
					prop: 'licensePlate',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					width: '150px',
					align: 'right'
				},

				{
					label: this.getMessage_('QWCC001101'), //자재비
					width: '150px',
					prop: 'mtrlCst',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001102'), //'공임비',
					width: '150px',
					prop: 'wags',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001103'), //'부대비',
					width: '150px',
					prop: 'incdCst',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC002137'), //'服务站费用',
					width: '150px',
					prop: 'dlrCpnyFee',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC002138'), //'非保修总金额',
					width: '150px',
					prop: 'nonWarrantyFee',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC002139'), //'保修总金额',
					width: '150px',
					prop: 'warrantyFee',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001104'), //'총금액',
					width: '150px',
					prop: 'totPartCst',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC000053'), //'特殊事项',
					width: '150px',
					prop: 'prtlSbc',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001184'), // 维修完成日
					prop: 'ceqEndDd',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000979'), // 신청일자
					prop: 'aplcDd',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('MWCC000980'), // 확정일자
					prop: 'dcsnDd',
					width: '150px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001251'), //신청자
					prop: 'aplcNm',
					width: '130px',
					align: 'center'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		costUpShow(){
			this.$emit('CostUpShow');
		},
		roCostMatch(){
			this.roCostMatch_().then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});;
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			/*날짜 포멧변환*/
			let roStartDt, roEndDt, causPartNo;

			//날짜 값이 없으면 날짜 포멧을 할수가 없다.
			if (this.searchParams.roStartDt) {
				roStartDt = moment(this.searchParams.roStartDt).format('YYYYMMDD');
			} else {
				roStartDt = '';
			}

			if (this.searchParams.roEndDt) {
				roEndDt = moment(this.searchParams.roEndDt).format('YYYYMMDD');
			} else {
				roEndDt = '';
			}

			/*특수문자가 있는것들은 다음과 같이해줘됨 */
			if (this.searchParams.causPartNo) {
				causPartNo = encodeURIComponent(this.searchParams.causPartNo);
			} else {
				causPartNo = '';
			}

			queryStr = objectToQuerystring({
				roNo: this.searchParams.roNo /*roNo*/,
				dlrCpnyCd: this.searchParams.dlrCpnyCd /*딜러점*/,
				prcStepGb: this.searchParams.prcStepGb /*처리단계*/,
				prcRsltCd: this.searchParams.prcRsltCd /*처리결과*/,
				ceqType: this.searchParams.ceqType /*정비유형*/,
				ctype: this.searchParams.ctype /*ctype*/,
				rptpStCd: this.searchParams.rptpStCd /*고품회수상태*/,
				prcPwaDd: this.searchParams.prcPwaDd /*날짜검색구분값from*/,
				causPartNo: causPartNo /*원인부품번호*/,
				roStartDt: roStartDt /*신청일자from*/,
				roEndDt: roEndDt /*신청일자to*/,
				cmpnNo: this.searchParams.cmpnNo /*켐페인번호 */,
				aplcNm: this.searchParams.aplcNm, /*신청자*/
				carVin: this.searchParams.carVin,
				causOpCd: this.searchParams.causOpCd,
				outBoundStatus: this.searchParams.outBoundStatus,
				pmcId: this.searchParams.pmcId
			});

			//console.log('조회조건>>>>', queryStr);

			//console.log('엑셀컬럼>>>', this.roApcnExCols);

			const url = `${BASE_URL}/mqy/ceqi/roApcn/v1/excels` + queryStr;

			const params = { url, columns: this.roApcnExCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		
		openRoEditModal(row) {
			/*RO 상세조회*/
			//console.log('ro 번호 클릭시 값은>>>>', row);
			const param = {
				title: this.getMessage_('QWCC001769'), //RO 상세
				roNo: row.roNo
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		openPwaModal(row) {
			// pwa 신규등록
			//console.log('pwa번호 클릭시 값은>>>>', row);
			const param = {
				title: this.getMessage_('QWCC001768'), //pwa 상세
				pwaNo: row.pwaNo
			};

			//console.log('값은>>>>>', param);

			this.$emit('PopupPwaOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		openRoNewModal() {
			// RO 신규등록
			const param = {
				title: this.getMessage_('QWCC001042'), //RO 신청현황
				roNo: '',
				pwaNo: '',
				scrId: ''
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		openRtnPartModal() {
			/*고품분석*/
			const selected = this.$refs.RoApcnTable.getSelectedRows();

			if (selected.length === 0) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			//보증수리일경우 '10'
			if (selected[0].ceqType == '10') {
				//console.log('선택한값은', selected);

				if (selected.length > 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('QWCC001166'),
						message: this.getMessage_('QWCC001166')
					}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
					return;
				}

				//console.log('값은 상태값>>>', selected[0].prcsRslt);
				//console.log('값은 ro >>>', selected[0].ro);

				//선택한 RO번호
				const selRoNo = convertNvl(selected[0].roNo, '');

				//RO신청시 승인된건이면서 RO번호가 없는것들만 RO를 신청할수가 있다.

				if (selected[0].prcsRslt === '10') {
					// RO 신규등록
					const param = {
						title: this.getMessage_('QWCC001246'), //고품회수신청
						roNo: selRoNo
					};

					//console.log('param', param);

					this.$emit('registerRtnPart', param); //상위(Content.vue)에 정의한  registerRtnPart함수실생 실행한다.
				} else {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('QWCC001770'),
						message: this.getMessage_('MWCC000110')
					}); //승인된 데이터를 선택해주세요. / 선택된 데이터가 없습니다.
					return;
				}
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001907') });
			}
		},
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		roListAppr() {
			// 그리드에서 RO일괄승인
			const selected = this.$refs.RoApcnTable.getSelectedRows();

			this.setState_({ key: 'selectedRoApcnList', value: _.cloneDeep(selected) });

			if (selected.length === 0) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			let saveChkListRows = this.chkListRoApprRows_; //getters

			if (saveChkListRows.length > 0) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000110'),
					message: this.getMessage_('QWCC001989')
				}); //신청된 데이터를 선택해주세요. / 선택된 데이터가 없습니다.
				return;
			} else {
				//console.log('저장할 값>>>>', saveChkListRows);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001155'), //승인하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprSaveRoList() }]
				});
			}
		},
		outBound(){
			const selectedRows = this.$refs.RoApcnTable.getSelectedRows();
			if (selectedRows.length === 0) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); 
				return;
			}
			const outBoundRows = selectedRows.filter(row => row.outBoundStatus === '1');
			if(outBoundRows && outBoundRows.length > 0){
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('QWCC002150')
					//message: this.getMessage_('QWCC002150')
				}); 
				return;
			}
			const noCrRows = selectedRows.filter(row => (row.prcsRslt != '10' || row.prcsStep != '30'));
			if(noCrRows && noCrRows.length > 0){
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('QWCC001770')
					//message: this.getMessage_('QWCC002150')
				}); 
				return;
			}
			const roNoList = selectedRows.map(row => row.roNo);
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('QWCC002151'), //승인하시겠습니까?
				buttons: [{ title: this.getMessage_('QWCC002149'), clickFn: () => this.apprSaveRoOutBound(roNoList) }]
			});
		},
		async apprSaveRoOutBound(roNoList){
			let formData = new FormData();

			formData.append('roNoList', roNoList);

			await this.apprSaveRoOutBound_({ formData }) .then(response => {
				if (response.header.message != undefined && response.header.message != null) {
					this.$sf_toast({
						type: response.header.code === 0 ? 'ok' : 'error',
						message: this.getMessage_(response.header.messageCd)
					});
				}

				this.$emit('Refresh');
			})
			.catch(error => {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
			})
			.finally(() => {
				this.$sf_toggleLoading(false);
			});
		},
		async apprSaveRoList() {
			let formData = new FormData();

			if (this.selectedRoApcnList.length > 0) {
				this.selectedRoApcnList.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						formData.append('partList[' + index + '].' + key, element[key]);
					});
				});
			} else {
				formData.append('partList', '');
			}

			await this.apprSaveRoList_({ formData })
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}

					this.$emit('Refresh');
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style>
.el-table .is-group > tr:first-of-type th {
	padding: 0px 0px 0px 5px;
}
</style>
